const OrderEvents = ({ events }) => (
	<div className="timeline">
		{events?.map((e) => (
			<EventEntry key={e.ts} ts={e.ts} event={e.event} />
		))}
	</div>
);

const EventEntry = ({ ts, event }) => {
	let [date, time] = ts.split("T");
	return (
		<div className="timeline-item timeline-item-secondary">
			<div className="event-ts">
				{date} {time.split(".")[0]}
			</div>
			<div className="event-body">
				{event
					.split(/\n/g)
					.filter((line) => line.trim())
					.map((line, i) => {
						const parts = line.replace(/\\"/g, "").split(": ", 2);
						if (parts.length < 2) {
							return (
								<div className="event-row" key={i}>
									<span className="event-val">{parts[0].replace(/"/g, "")}</span>
								</div>
							);
						}
						const key = parts[0];
						const val = parts[1];
						const transition = val.split(/->/);
						if (transition.length > 1) {
							return (
								<div className="event-row-vertical" key={i}>
									<span className="event-key">{key}</span>
									<div className="event-diff">
										<div className="event-diff-line">
											<span className="event-from">
												{transition[0].replace(/"/g, "").trim()}
											</span>
										</div>
										<div className="event-diff-line">
											<span className="event-to">
												{transition[1].replace(/"/g, "").trim()}
											</span>
										</div>
									</div>
								</div>
							);
						}
						return (
							<div className="event-row" key={i}>
								<span className="event-key">{key}</span>
								<span className="event-val">
									{val.replace(/"/g, "")}
								</span>
							</div>
						);
					})}
			</div>
		</div>
	);
};

export default OrderEvents;
